export const GLYCEMIA_TYPES = ['jejum', 'pos_1h', 'pos_2h', 'outro'];
export const GLYCEMIA_TYPE_LABELS = {
  jejum: 'Jejum',
  pos_1h: '1h pós-prandial',
  pos_2h: '2h pós-prandial',
  outro: 'Outro',
};

// Limit for a reading type, coerced to a number or null (no limit defined).
export function limitFor(limits, type) {
  const v = (limits || {})[type];
  const n = v === null || v === undefined || v === '' ? null : parseFloat(v);
  return Number.isFinite(n) ? n : null;
}

// A reading is over the limit only when its type has a defined limit AND value > limit.
// Returns true/false/null (null = no limit defined for this type → ignored in metrics).
export function isOverLimit(record, limits) {
  const lim = limitFor(limits, record.reading_type);
  if (lim === null) return null;
  const val = parseFloat(record.value);
  if (!Number.isFinite(val)) return null;
  return val > lim;
}

const isoWeek = (d) => { const dt = new Date(d + 'T00:00:00'); const day = dt.getUTCDay() || 7; dt.setUTCDate(dt.getUTCDate() + 4 - day); const ys = new Date(Date.UTC(dt.getUTCFullYear(), 0, 1)); return `${dt.getUTCFullYear()}-W${String(Math.ceil((((dt - ys) / 86400000) + 1) / 7)).padStart(2, '0')}`; };
const weekRange = (d) => { const dt = new Date(d + 'T00:00:00'); const day = (dt.getUTCDay() + 6) % 7; const mon = new Date(dt); mon.setUTCDate(dt.getUTCDate() - day); const sun = new Date(mon); sun.setUTCDate(mon.getUTCDate() + 6); const fmt = (x) => `${String(x.getUTCDate()).padStart(2, '0')} ${x.toLocaleString('pt-PT', { month: 'short', timeZone: 'UTC' }).replace('.', '')}`; return `${fmt(mon)}–${fmt(sun)}`; };

// "% de leituras dentro do intervalo" por semana ISO.
// Só considera leituras cujo tipo TEM limite definido; ignora as restantes.
export function computeWeeklyWithinRange(records, limits) {
  const buckets = {};
  (records || []).forEach(r => {
    const lim = limitFor(limits, r.reading_type);
    if (lim === null) return; // ignora tipos sem limite
    const val = parseFloat(r.value);
    if (!Number.isFinite(val)) return;
    const k = isoWeek(r.date);
    if (!buckets[k]) buckets[k] = { week: k, label: weekRange(r.date), total: 0, within: 0 };
    buckets[k].total += 1;
    if (val <= lim) buckets[k].within += 1;
  });
  return Object.values(buckets)
    .filter(b => b.total > 0)
    .sort((a, b) => a.week.localeCompare(b.week))
    .map(b => ({ ...b, pct: Math.round((b.within / b.total) * 100) }));
}
